var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.accountTypes.selectedAccount.account_type == 'DEMO'
      ? 'theme-demo'
      : _vm.accountTypes.selectedAccount.account_type == 'CONTEST'
        ? 'theme-camp'
        : '',
    'text-ontick-carbon-900 dark:text-gray-300',
  ]},[(_vm.is_loading || _vm.config_error)?[_c('transition',{attrs:{"enter-active-class":"ease-in-out duration-300","enter-class":"opacity-0","enter-to-class":"opacity-100","leave-active-class":"ease-in-out duration-300","leave-class":"opacity-100","leave-to-class":"opacity-0"}},[(_vm.is_loading)?_c('ontick-loading-screen-component'):_c('ontick-error-screen-component')],1)]:_c('vue-page-transition',{staticClass:"overflow-hidden bg-transparent",attrs:{"name":"fade-in-right"}},[_c('router-view')],1),_c('portal-target',{attrs:{"name":"modal","multiple":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }